import React from "react";

import ProjectTop from "./ProjectTop";

import { useAppSelector } from "../../redux/hooks";
import {
  getAuthToken,
  getAuthStatus,
  AuthStatus,
} from "../../redux/reducers/auth";

import { useMetaData } from "../../utils/useMetaData";
import { useGetTopProject } from "../../utils/useProject";

export const ProjectTopContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);
  const auth_status = useAppSelector(getAuthStatus);

  const {
    newProjects,
    endProjects,
    tryoutProjects,
    auditionProjects,
    isLoading,
  } = useGetTopProject({
    auth_token,
    enabled: auth_status !== AuthStatus.Loading,
  });

  useMetaData({
    title: "eスポーツプロジェクトTOP",
    description:
      "eスポーツを使ったPRやイベントキャスティングサービス「SELeCT」のeスポーツやゲームに関するプロジェクト一覧ページです。イベントアルバイトやスタッフ求人、運営メンバー、協賛スポンサー募集など様々な情報を掲載しています。求人探しなどにお役立てください。",
    imgUrl: "",
  });

  return (
    <ProjectTop
      // pickupProject={pickupProject}
      newProject={newProjects}
      endProject={endProjects}
      tryoutProject={tryoutProjects}
      auditionProject={auditionProjects}
      isLoading={isLoading}
      showEmptyState={
        !isLoading &&
        // pickupProject.length == 0 &&
        newProjects.length == 0 &&
        endProjects.length == 0 &&
        tryoutProjects.length == 0 &&
        auditionProjects.length == 0
          ? true
          : false
      }
    />
  );
};
